import { Button, Div, Ref, Text } from "@tblabs/truffle";
import moment from "moment";


export class DateTimeSlider extends Div
{
    constructor(dateRef: Ref<Date>, now = () => new Date())
    {
        super();
        this.TextAlignCenter().DisplayInlineBlock().Background("#fefefe").BorderRadius(32).Padding(0, 4).Color("#222")

        const dateInput = new Text(dateRef, v => moment(v as string).format("DD.MM.YYYY HH:mm"));

        if (this.IsInvalidDate(dateRef.value))
        {
            dateInput.Border(3, "#ff6565").BorderStyle("dashed");
        }

        this.Append(
            new Button("◂").FontSize(22).Padding(0).BorderNone().MarginRight(4).OnClick(() => dateRef.value = moment(dateRef.value).add(-1, 'hour').toDate()),
            new Button("◀").FontSize(22).Padding(0).BorderNone().MarginRight(4).OnClick(() => dateRef.value = moment(dateRef.value).add(-1, 'day').toDate()),
            dateInput,
            new Button("▶").FontSize(22).Padding(0).BorderNone().MarginLeft(8).OnClick(() => dateRef.value = moment(dateRef.value).add(1, 'day').toDate()),
            new Button("▸").FontSize(22).Padding(0).BorderNone().MarginLeft(8).OnClick(() => dateRef.value = moment(dateRef.value).add(1, 'hour').toDate()),
            new Button("Now").Padding(0).BorderNone().MarginLeft(8).OnClick(() => dateRef.value = now()),
        );
    }

    private IsInvalidDate(date: Date): boolean
    {
        try
        {
            return isNaN(date.getTime());
        }
        catch (e)
        {
            return true;
        }
    }
}
